import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20flatlay%20photography%20of%20curated%20fashion%20products%20arranged%20on%20warm%20sand%20colored%20linen%20surface%20featuring%20sneakers%20hoodies%20tshirts%20bags%20and%20accessories%20in%20organized%20grid%20composition%20soft%20morning%20light%20from%20large%20window%20casting%20gentle%20diagonal%20shadows%20editorial%20aesthetic%20with%20organic%20textures%20minimalist%20european%20style%20calm%20sophisticated%20atmosphere%20high%20end%20catalog%20feel&width=1600&height=900&seq=hero-hoobuy-v2-2026&orientation=landscape"
          alt="HoobuySpreadsheet products background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-20 md:py-24">
        <div className="max-w-3xl">
          {/* Label tag */}
          <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-medium text-background-50/90 border border-background-50/40 rounded-full mb-6 whitespace-nowrap">
            HoobuySpreadsheet 2026
          </span>

          {/* H1 */}
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight mb-4">
            A Melhor Forma de Encontrar{' '}
            <span className="italic font-normal text-accent-300">Produtos Premium</span>{' '}
            Organizados
          </h1>

          {/* Subheadline */}
          <p className="text-sm md:text-base text-background-50/80 max-w-xl mb-8 leading-relaxed">
            Descubra as melhores spreadsheets do Hoobuy com atualizações diárias, produtos virais e
            guias completos para economizar dinheiro em compras internacionais.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm md:text-base font-semibold rounded-lg bg-accent-500 text-background-50 hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Ver HoobuySpreadsheet Atualizado
              <i className="ri-arrow-right-line"></i>
            </a>
            <Link
              to="/artigo/guia-de-compras-hoobuy-2026"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm md:text-base font-medium rounded-lg bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
            >
              Guia de Compras 2026
              <i className="ri-shopping-bag-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}